import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Section } from 'src/app/modules/route-planner/interfaces/route-planning/section.interface';
import { SourceDestinationForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/source-destination-form';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { REACHED_DESTINATION } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Direction } from '@angular/cdk/bidi';
import { Coordinate } from 'src/app/modules/route-planner/interfaces/location/coordinate.interface';

@Component({
    selector: 'app-detailed-result-route-destination',
    templateUrl: './detailed-result-route-destination.component.html',
    styleUrls: ['./detailed-result-route-destination.component.scss'],
    standalone: false
})
export class DetailedResultRouteDestinationComponent implements OnInit {
  @Input() formValues: SourceDestinationForm;
  @Input() section: Section;
  @Output() focusLocationEvent: EventEmitter<Coordinate> = new EventEmitter<Coordinate>();
  reachedDestinationText: string
  direction: Direction

  constructor(private readonly languageService: LanguageService) { }

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.reachedDestinationText = REACHED_DESTINATION[language.language]
    })
  }
}
